export const addressSearchPageTranslations = {
  pageTitle: 'Sök Adress',
  pageDescription: 'Kontrollera om erbjudandet är tillgängligt på din adress.',
  searchInputLabel: 'Ange adress',
  accessSearchInputLabel: 'Ange access-id',
  searchInputPlaceholder: 'Skriv adress här...',
  accessSearchInputPlaceholder: 'Skriv access-id här...',
  searchSelectApartment: 'Välj byggnad',
  searchSelectApartmentPlaceholder: 'Välj',
  noResultsFoundTitle:
    'Tyvärr hittar vi inte din adress men du kan lämna en intresseanmälan!',
  genericSupplyButton: 'Se tjänsteutbud',
  inquirable: {
    header:
      'Attans! Det verkar som att vi inte har någon pågående försäljning i ditt område.',
    description1: 'Just nu har vi ingen pågående försäljning till ',
    description2:
      '. Du får gärna göra en intresseanmälan tills vidare eftersom det hjälper oss att se vart intresset finns för en framtida fiberutbyggnad. Du är även välkommen att kontakta kundservice på 0200 43 00 00 eller via kundservice@globalconnect.se för att se över möjligheten att beställa fiber till din adress.',
    buttonText: 'Lämna intresseanmälan',
  },
  inquired: {
    header: 'Tack! Vi har redan din intresseanmälan.',
    description1:
      'Du har sedan tidigare lämnat en intresseanmälan för fiber till',
    description2:
      '. Dessvärre har vi inte möjlighet att ansluta fastigheten till vårt fibernät just nu, men din intresseanmälan är ett viktigt underlag som hjälper oss att planera inför framtida fiberutbyggnad.',
  },
  orderable: {
    header: 'Jippi! Du kan få snabbt bredband via fiber från GlobalConnect.',
    description1: 'Vi finns i ditt område och kan ansluta din fastighet på',
    description2:
      'till vårt öppna fibernät. Klicka på knappen nedan och beställ fiber idag!',
    buttonText: 'Till fiberportalen',
  },
  ordered: {
    header:
      'Håll ut! Snart har du snabbt bredband via fiber från GlobalConnect.',
    description1: 'Fiber är beställd till',
    description2:
      '. Så snart vi har kopplat upp fastigheten till vårt öppna fibernät kan du beställa bredband, tv och telefoni från den tjänsteleverantör som passar dig och dina önskemål bäst. Klicka på knappen nedan om du vill se vårt tjänsteutbud eller ändra dina kontaktuppgifter.',
    buttonText: 'Till fiberportalen',
  },
  orderedMdu: {
    header: 'Fiber från GlobalConnect är på väg till ',
    description1:
      'När fiber är ansluten är det fritt fram att beställa bredband, tv och telefoni i vårt öppna fibernät.',
    description2:
      'Om du vill vara redo kan du kika på tjänsteutbudet redan nu.',
  },
  installed: {
    header: 'Du kan beställa bredbandstjänster till fastigheten!',
    description1:
      'Du kan beställa bredband, tv och telefoni till din fasighet på',
    description2:
      '. Välj tjänster och leverantör utifrån vad som passar dig och dina önskemål bäst. Klicka på knappen nedan för att komma till tjänsteportalen.',
    buttonText: 'Till tjänsteportalen',
  },
  cancelled: {
    header: 'Tråkigt att du lämnar oss...',
    description1: 'Fiberbeställningen på',
    description2:
      'är nu annullerad och det tycker vi är jättetråkigt. Om du ångrar dig eller har andra frågor är du välkommen att kontakta vår kundservice.',
  },
};
